// extracted by mini-css-extract-plugin
module.exports = {"container":"_18L2LVrML0itQb2iLoA2s4","groupsList":"_2Q1GoeB0lopkYbsnm5apod"};